import { useMutation, useQueryClient } from "@tanstack/react-query";
import { locationServices } from "./location.services";
import { LOCATION_KEYS } from "./location.keys";
import { CreateLocationParams, StorageSettings } from "./location.types";

export const useCreateLocation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: locationServices.createLocation,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: LOCATION_KEYS.GET_LOCATIONS(),
      });
    },
  });
};

export const useUpdateLocation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      params,
    }: {
      id: string;
      params: Partial<CreateLocationParams>;
    }) => locationServices.updateLocation(id, params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: LOCATION_KEYS.GET_LOCATIONS(),
      });
    },
  });
};

export const useDeleteLocation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => locationServices.deleteLocation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: LOCATION_KEYS.GET_LOCATIONS(),
      });
    },
  });
};

export const useUpdateStorageSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: StorageSettings) =>
      locationServices.updateStorageSettings(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: LOCATION_KEYS.GET_STORAGE_SETTINGS(),
      });
    },
  });
};
